<template>
        <div class="warp">
            <!-- 面包屑 -->
            <breadcrumb :back="true" :crubList="[{name:'审核管理'},{name:'资讯发布审核',goback:true},{name:'资讯发布审核详情'}]" :title="'资讯发布审核详情'"/>
            <!-- 主体内容 -->
            <!-- 用户明细 -->
            <div class="box">
               <el-card class="basic box_card" header="账号信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                     <div class="child">
                            <div class="name">账号：</div>
                            <div class="content">{{dataInfo.createUserName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8" v-if="dataInfo.userVo">
                    <div class="child">
                            <div class="name">姓名：</div>
                            <div class="content">{{dataInfo.createName||'--'}}</div>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="资讯信息" shadow="never">
                 <el-row>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">资讯标题：</div>
                            <div class="content">{{dataInfo.title||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">适用行业：</div>
                            <div class="content">{{dataInfo.createUserName||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">资讯简介：</div>
                            <div class="content">{{dataInfo.summary||'--'}}</div>
                        </div>
                  </el-col>
                  <el-col :span="8">
                    <div class="child">
                            <div class="name">来源：</div>
                            <div class="content">{{dataInfo.source||'--'}}</div>
                        </div>
                  </el-col>
                 </el-row>
                 <el-row>
                  <el-col :span="8">
                    <div class="richText">
                            <div class="name">资讯详情：</div>
                            <div class="content" v-html="dataInfo.content">{{dataInfo.createUserName||'--'}}</div>
                        </div>
                  </el-col>
                   </el-row>
                 <el-row>
                  <el-col :span="24">
                    <div class="attachment">
                            <div class="name">附件：</div>
                            <ul class="content">
                                <li v-for="(i,index) in dataInfo.fileList" :key="index">
									<span>{{i.fileName}}</span>
									<i class="el-icon-download" @click="downLoad(dataInfo.frontPath+i.filePath)"></i>
								</li>
                            </ul>
                        </div>
                  </el-col>
                </el-row>
              </el-card>
              <el-card class="basic box_card mt16" header="审核结果" shadow="never" v-if="tab==='2'">
                <el-row>
                    <el-col :span="8">
                      <div class="child">
                              <div class="name">审核结果：</div>
                              <div class="content">{{dataInfo.checkStatusValue}}</div>
                          </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核账号：</div>
                            <div class="content">{{dataInfo.modifyUserName}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">审核时间：</div>
                            <div class="content">{{dataInfo.updateTime}}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                      <div class="child">
                            <div class="name">说明：</div>
                            <div class="content">{{dataInfo.auditInstructions}}</div>
                        </div>
                    </el-col>
                  </el-row>
              </el-card>
              
            </div>
        </div>
</template>

<script>
import breadcrumb from '../../components/breadcrumb';
export default {
    components:{
        breadcrumb
    },
    data(){
        return{
            tab:'1',//选项卡
            id:'',//详情id
            dataInfo:{
               createUserName: "", //账号
                    createName: "",//姓名
                    debtProductName: "",//产品名称
                    loanTypeValue: "",//贷款类型
                    maxAmount: "",//最高额度
                    minAmount: "",//最低额度
                    loanTerm: "",//贷款期限
                    guaranteeWay: "",//担保方式
                    fileList: [],//附件列表
                    yearInterest: '',//年利率
                    productIntro: "",//产品介绍
                    createName: "",//发布账号
                    createTime: "",//发布时间
                    modifyName: "",//发布账号
                    updateTime: "",//发布账号
                    checkStatusValue: '',//审核状态
                    modifyUserName: "",//审核账号
                    updateDate: '',//审核时间
                    checkExplanation: "",//说明
                    loanKnown: [],
                    userVo: {
                        email: "",//邮箱
                        contactAddress: "",//联系地址
                        companyName: "",
                        userName: "",//用户名
                        userTypeName: "",//用户类型
                    }
            },//数据
			debtStatistics:'',//债权融资统计
			financialLeasingStatistics:'',//融资租赁统计
			equityStatistics:'',//股权融资列表统计
			vouchStatistics:'',//担保服务统计
			policyGuidanceStatistics:'',//政策指引统计
			incubatorStatistics:'',//孵化器统计
			activitySalonStatistics:'',//活动沙龙统计
      center: {}, //地图中心点
			maker: {}, //标记点
			zoom: 15, //缩放等级
        }
    },
    methods:{
        open(){
          this.$alert('点击附件')
        },
        //获取数据
        async getData(){
         const {code,data,msg} = await this.$axiosc.get('/backstage/news/reviewLog/details/'+this.id)
          if (code == 200) {            
              this.dataInfo = data 
          } else {
              this.$alert(msg)
          }
        }
    },
    created(){
        this.tab=this.$route.params.type
        this.id=this.$route.query.id;
    },
    mounted(){
        this.getData();
    }
}
</script>

<style lang="scss" scoped>
.warp{
  height:100%;
  overflow: hidden;
}
.box{
  height: calc(100% - 40px);
    overflow-x: hidden;
    overflow-y: auto;
    // margin-top: 20px;
    &_card{
      border:none;
      &::v-deep{
        .el-card__header{
          font-size: 16px;
          color: #262626;
          padding:14px 22px !important;
          border-bottom-color:#E5E5E5;
        }
        .el-card__body{
          padding:24px 25px !important;
        }
      }
    }
}
.basic{
  color:$font;
  font-size: 14px;
  font-weight: 400;
  line-height: 40px;
  // background: #fff;
  .el-col{
    margin: 10px 0;
  }
  .child{
    color:#595959;
  }
}
.main{
  background: transparent !important;
  padding:0 !important;
}
</style>